import React from 'react'
import { useRoutes } from 'react-router-dom'
import AdminRoutes from '../admin-app/AdminRoutes'
import Casino from '../pages/casino/casino'
import CasinoOther from '../pages/casino/casinoOther'
import CasinoHubPage from '../pages/casino/CasinoHubPage'
import DepositStatement from '../pages/depositstatement/depositstatement'
import WithdrawStatement from '../pages/withdrawstatement/withdrawstatement'
import DashboardRedirect from '../components/DashboardRedirect'
import AffilateRoutes from '../affilate-app/AffilateRoutes'
import ProtectedRoute from '../components/ProtectedRoute'
const AccountStatement = React.lazy(() => import('../pages/AccountStatement/AccountStatement'))
const BetHistory = React.lazy(() => import('../pages/BetHistory/BetHistory'))
const ButtonValues = React.lazy(() => import('../pages/button-values/button-values'))
const CasinoReport = React.lazy(() => import('../pages/CasinoReport/CasinoReport'))
const ChangePassword = React.lazy(() => import('../pages/ChangePassword/ChangePassword'))
const Dashboard = React.lazy(() => import('../pages/dashboard/dashboard'))
const Login = React.lazy(() => import('../pages/login/login'))
const LegalPage = React.lazy(() => import('../pages/login/LegalPage'))
const Odds = React.lazy(() => import('../pages/odds/odds'))
const ProfitLoss = React.lazy(() => import('../pages/PlReport/ProfitLoss'))
const UnsetteleBetHistory = React.lazy(
  () => import('../pages/UnsetteleBetHistory/UnsetteleBetHistory'),
)
const AuthLayout = React.lazy(() => import('../pages/_layout/AuthLayout'))
const Main = React.lazy(() => import('../pages/_layout/Main'))
const CasinoList = React.lazy(() => import('../pages/CasinoList/CasinoList'))
const Rules = React.lazy(() => import('../pages/Rules/rules'))
const TransactionPassword = React.lazy(
  () => import('../admin-app/pages/transaction-password/transaction-password'),
)
const CheckTransactionPassword = React.lazy(
  () => import('../pages/_layout/CheckTransactionPassword'),
)
const Page404 = React.lazy(() => import('../pages/404/404'))
const CasinoWrapper = React.lazy(() => import('../pages/CasinoList/CasinoWrapper'))
const CasinoLiveShell = React.lazy(() => import('../casino-d247/CasinoLiveShell'))
const CasinoLiveLobby = React.lazy(() => import('../casino-d247/pages/Lobby'))
const CasinoLiveTable = React.lazy(() => import('../casino-d247/pages/Table'))
const ResultList = React.lazy(() => import('../pages/CasinoList/component/_common/ResultList'))
const SecurityAuth = React.lazy(() => import('../pages/Rules/SecurityAuth'))
const Routers = () => {
  const routes = [
    {
      path: '/login',
      element: <AuthLayout />,
      children: [{ index: true, element: <Login /> }],
    },
    {
      path: '/terms-and-conditions',
      element: <AuthLayout />,
      children: [
        {
          index: true,
          element: (
            <LegalPage title='Terms and Conditions'>
              <p>Please read these terms and conditions carefully before using this website.</p>
            </LegalPage>
          ),
        },
      ],
    },
    {
      path: '/responsible-gaming',
      element: <AuthLayout />,
      children: [
        {
          index: true,
          element: (
            <LegalPage title='Responsible Gaming'>
              <p>We promote responsible gaming. Please play within your limits.</p>
            </LegalPage>
          ),
        },
      ],
    },
    {
      path: '/transaction-password',
      element: <TransactionPassword />,
    },
    {
      path: '/admin/transaction-password',
      element: <TransactionPassword />,
    },
    {
      path: '/',
      element: <ProtectedRoute><CheckTransactionPassword /></ProtectedRoute>,
      children: [
        { path: 'maintenance', element: <h4>Under Main</h4> },
        {
          path: '/',
          element: <Main />,
          children: [
            { index: true, element: <DashboardRedirect /> },
            { path: 'dashbaord', element: <Dashboard /> },
            { path: 'match/:sportId', element: <Dashboard /> },
            { path: 'match/:sportId/:status?', element: <Dashboard /> },
            { path: 'odds/:matchId', element: <Odds /> },
            { path: 'button-values', element: <ButtonValues /> },
            { path: '/changepassword', element: <ChangePassword /> },
            { path: '/bethistory', element: <BetHistory /> },
            { path: '/accountstatement', element: <AccountStatement /> },
            { path: '/unsettledbet', element: <UnsetteleBetHistory /> },
            { path: '/casinoreport', element: <CasinoReport /> },
            { path: '/profitloss', element: <ProfitLoss /> },
            { path: '/casino-games', element: <CasinoList /> },
            { path: '/casino-in/:type', element: <Casino /> },
            { path: '/casino-int/:type', element: <CasinoOther /> },
            { path: '/casino-hub/:slug', element: <CasinoHubPage /> },
            {
              path: '/casino-live',
              element: <CasinoLiveShell />,
              children: [
                { index: true, element: <CasinoLiveLobby /> },
                { path: ':gtype', element: <CasinoLiveTable /> },
              ],
            },
            { path: '/rules', element: <Rules /> },
            { path: '/casino/:gameCode/:matchId', element: <CasinoWrapper /> },
            { path: '/casino/result', element: <ResultList /> },
            { path: '/casino/result/:matchid', element: <ResultList /> },
            { path: 'settings/security-auth', element: <SecurityAuth /> },
            { path: '/depositstatement', element: <DepositStatement /> },
            { path: '/withdrawstatement', element: <WithdrawStatement /> },
          ],
        },
        ...AdminRoutes(),
        ...AffilateRoutes(),
      ],
    },
    { path: '*', element: <Page404 /> },
  ]
  return useRoutes(routes)
}

export default Routers
